import { MultiSelect } from '@empathy/search-types';
import { COMPONENTS, DeepPartial, FacetsConfig, SLOTS } from '@empathybroker/ebx-gluon';

export const MOBILE_FACETS_CONFIG: DeepPartial<FacetsConfig> = {
  default: {
    facet: {
      components: {
        icon: 'ChevronDownIcon',
        filter: {
          checkbox: 'TuandcoFacetsTick'
        }
      }
    }
  },
  facets: {
    color_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnFrontend
      },
      components: {
        filter: {
          checkbox: 'TuandcoFacetsTick'
        }
      }
    },
    brand_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnBackend
      }
    },
    promociones_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnBackend
      }
    },
    price_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnBackend
      }
    }
  },
  groups: {
    'all-facets': {
      templateSlots: {
        panel: SLOTS.template.overlay,
        toggle: SLOTS.template.footer
      },
      components: {
        selectedFilters: {
          selectedFilters: COMPONENTS.PURE.SelectedFilters,
          removeIcon: 'TuandcoCloseIcon'
        },
        header: 'TuandcoPanelClose'
      },
      facets: {
        promociones_facet: {},
        hierarchical_category: {},
        price_facet: {},
        brand_facet: {},
        abonos_y_substratos_facet: {},
        acabado_facet: {},
        accesorio_facet: {},
        tipo_de_accesorio_facet: {},
        ventilador_accionado_por_facet: {},
        altura_ajustable_facet: {},
        altura_del_césped_facet: {},
        altura_facet: {},
        alto_mampara_facet: {},
        ancho_campana_facet: {},
        ancho_cortina_de_baño_facet: {},
        medida_de_ancho_facet: {},
        ángulo_de_la_bisagra_facet: {},
        angulo_de_riego_facet: {},
        arboles_facet: {},
        medida_arco_de_sierra_facet: {},
        asiento_facet: {},
        aspersores_facet: {},
        aumentos_facet: {},
        baños_en_casa_facet: {},
        medida_de_la_barrena_facet: {},
        bastidor_para_facet: {},
        boca_cuadrada_facet: {},
        boca_hexagonal_facet: {},
        caño_extraible_facet: {},
        capacidad_facet: {},
        capacidad_del_deposito_facet: {},
        capacidad_refrigeración_facet: {},
        caudal_facet: {},
        caudal_y_ángulo_de_la_boquilla_facet: {},
        diámetro_cazoleta_bisagra_facet: {},
        código_de_curva_facet: {},
        colección_facet: {},
        color_facet: {},
        columna_para_facet: {},
        tipo_de_combustible_facet: {},
        combustible_barbacoa_facet: {},
        conexión_del_termostato_facet: {},
        conjunto_facet: {},
        numero_de_cubetas_facet: {},
        medidas_cubierta_de_invierno_facet: {},
        medidas_cubierta_isotérmica_facet: {},
        depuradora_facet: {},
        punta_phillips_facet: {},
        punta_plana_facet: {},
        punta_pozidriv_facet: {},
        punta_recta_facet: {},
        punta_torx_facet: {},
        medida_del_botador_facet: {},
        medidas_diámetro_facet: {},
        medida_piscina_hinchable_facet: {},
        diámetro_tubería_facet: {},
        difusores_facet: {},
        tipo_de_duchas_facet: {},
        tipo_de_pulsación_facet: {},
        encendido_calentador_facet: {},
        entrada_de_agua_facet: {},
        espesor_del_aislamiento_facet: {},
        estaciones_facet: {},
        salida_facet: {},
        medida_de_fondo_facet: {},
        forma_de_la_maceta_facet: {},
        funcionamiento_limpiafondos_facet: {},
        funcionamiento_facet: {},
        grapadoras_y_clavadoras_facet: {},
        grosor_del_accesorio_facet: {},
        grosor_de_pared_facet: {},
        grosor_poste_facet: {},
        hacha_facet: {},
        herramientas_coche_facet: {},
        herramienta_de_medición_facet: {},
        importe_facet: {},
        incluido_en_el_mueble_facet: {},
        ahumador_facet: {},
        bomba_dosificadora_facet: {},
        incluye_freno_facet: {},
        grifo_lavapiés_facet: {},
        incluye_termostato_facet: {},
        incorpora_grill_facet: {},
        tipo_de_instalación_del_grifo_facet: {},
        intensidad_facet: {},
        intensidad_regulable_facet: {},
        envase_facet: {},
        largo_de_la_barra_facet: {},
        led_integrado_facet: {},
        capacidad_de_limpieza_facet: {},
        capacidad_en_litros_facet: {},
        tipos_de_llave_facet: {},
        herramienta_de_corte_facet: {},
        macetas_facet: {},
        mando_a_distancia_facet: {},
        con_mando_a_distancia_facet: {},
        mangueras_facet: {},
        manufacturer_facet: {},
        marchas_atrás_facet: {},
        material_cepillo_facet: {},
        material_mueble_jardín_facet: {},
        material_plato_de_ducha_facet: {},
        medidas_de_la_caja_facet: {},
        medidas_de_cortafrío_facet: {},
        medidas_formón_facet: {},
        medidas_de_las_llaves_facet: {},
        medida_macetas_y_jardín_facet: {},
        medidas_martillo_y_mazas_facet: {},
        medidas_mesa_cultivo_facet: {},
        medida_de_la_paleta_facet: {},
        medida_rejilla_facet: {},
        medidas_de_la_manta_protectora_facet: {},
        medidas_facet: {},
        medida_de_la_canal_facet: {},
        medida_del_flexo_facet: {},
        medida_de_las_grapas_facet: {},
        medida_máxima_piscina_facet: {},
        medida_de_métrica_facet: {},
        medida_piscina_de_acero_facet: {},
        medida_piscina_tubular_facet: {},
        medida_rosca_facet: {},
        medida_de_la_rueda_facet: {},
        caldera_con_microacumulación_facet: {},
        modelo_grifería_facet: {},
        modelo_accesorio_de_baño_facet: {},
        modelo_aire_acondicionado_facet: {},
        modelo_bomba_facet: {},
        modelo_caldera_facet: {},
        modelo_calentador_facet: {},
        modelo_compresor_facet: {},
        modelo_del_cuchillo_facet: {},
        modelo_depósito_facet: {},
        modelo_descalcificador_facet: {},
        modelo_estufa_facet: {},
        modelo_lampara_facet: {},
        modelo_de_limpiafondos_facet: {},
        modelo_llave_de_radiador_facet: {},
        modelo_mampara_facet: {},
        modelo_máquina_facet: {},
        modelo_mecanismos_facet: {},
        modelo_de_muebles_facet: {},
        modelo_de_ósmosis_facet: {},
        modelo_piscina_facet: {},
        modelo_plato_facet: {},
        modelo_quemador_facet: {},
        modelo_radiador_facet: {},
        modelo_sanitario_facet: {},
        modelo_termostato_facet: {},
        modelo_termo_eléctrico_facet: {},
        modelo_tirador_facet: {},
        modelo_urinario_facet: {},
        alimentación_facet: {},
        mordaza_facet: {},
        mueble_con_facet: {},
        mueble_de_jardín_facet: {},
        número_de_calzado_facet: {},
        numero_de_contadores_facet: {},
        número_de_polos_facet: {},
        número_de_fuegos_facet: {},
        marchas_hacia_adelante_facet: {},
        número_de_módulos_facet: {},
        número_de_salidas_facet: {},
        número_de_tomas_facet: {},
        orificio_para_grifería_facet: {},
        para_instalar_en_facet: {},
        para_mueble_de_facet: {},
        peldaños_facet: {},
        perfiles_de_la_mampara_facet: {},
        personas_en_casa_facet: {},
        pirolítico_facet: {},
        piscinas_y_juegos_infantiles_facet: {},
        época_de_siembra_facet: {},
        plantas_facet: {},
        plantilla_de_instalación_incluida_facet: {},
        posición_del_escurridor_facet: {},
        potencia_kw_facet: {},
        selecciona_la_potencia_facet: {},
        presentación_facet: {},
        capacidad_de_producción_acs_facet: {},
        puntas_del_alicate_facet: {},
        puntas_allen_facet: {},
        tipo_de_reductor_facet: {},
        tipo_de_regulación_facet: {},
        remachadoras_facet: {},
        rollo_de_facet: {},
        número_de_proyectores_facet: {},
        semillas_facet: {},
        programadores_facet: {},
        sierra_marquetería_facet: {},
        soldadores_facet: {},
        superficie_de_cocción_facet: {},
        superficie_de_la_vivienda_facet: {},
        talla_facet: {},
        tamaño_facet: {},
        tamaño_del_saco_facet: {},
        grifo_termostático_para_facet: {},
        termostato_programable_facet: {},
        tipo_aspersor_facet: {},
        tipo_abrazadera_facet: {},
        tipo_de_acceso_facet: {},
        tipo_accesorio_de_baño_facet: {},
        tipo_de_accesorio_fontanería_facet: {},
        tipo_de_accionamiento_facet: {},
        tipo_de_coquilla_facet: {},
        tipo_de_alcuza_facet: {},
        tipo_de_alicate_facet: {},
        apertura_de_la_mampara_facet: {},
        tipo_de_azada_facet: {},
        tipo_de_barbacoa_facet: {},
        tipo_de_barra_facet: {},
        batería_de_contadores_facet: {},
        tipo_de_bidé_facet: {},
        tipo_de_bisagra_facet: {},
        tipo_de_bombilla_facet: {},
        tipo_de_caja_facet: {},
        tipo_de_caldera_facet: {},
        salida_de_humos_facet: {},
        tipo_de_camisa_facet: {},
        tipo_de_caño_facet: {},
        tipo_de_carretilla_facet: {},
        tipo_de_casco_facet: {},
        tipo_de_casquillo_facet: {},
        tipo_de_cepillo_facet: {},
        tipo_chaqueta_facet: {},
        tipo_tableta_facet: {},
        uso_del_cuchillo_facet: {},
        tipo_de_depósito_facet: {},
        destornillador_facet: {},
        instalación_facet: {},
        tipo_de_césped_facet: {},
        tipo_instalacion_facet: {},
        portamangueras_facet: {},
        tipo_de_rejilla_facet: {},
        escalera_para_piscinas_facet: {},
        tipo_de_escalera_facet: {},
        tipo_de_espejo_facet: {},
        estilo_facet: {},
        tipo_de_flexómetro_facet: {},
        combustible_facet: {},
        tipo_de_grifo_facet: {},
        tipo_de_guante_facet: {},
        tipo_de_guía_facet: {},
        tipo_de_guías_facet: {},
        tipo_de_inodoro_facet: {},
        tipo_de_juego_facet: {},
        tipo_de_lámpara_facet: {},
        tipo_de_limpiafondos_facet: {},
        tipo_de_llave_facet: {},
        tipo_de_luz_facet: {},
        tipo_de_mampara_facet: {},
        tipo_de_máquina_facet: {},
        tipo_de_martillo_facet: {},
        tipo_mascarilla_facet: {},
        tipo_de_mecanismo_facet: {},
        tipo_de_mono_de_trabajo_facet: {},
        conjunto_de_facet: {},
        tipo_de_nivel_facet: {},
        tipo_organizador_facet: {},
        tipo_de_osmosis_facet: {},
        tipo_de_pala_facet: {},
        tipo_de_pantalla_de_soldar_facet: {},
        tipo_pantalón_facet: {},
        tipo_de_piscina_facet: {},
        tipo_placa_cocción_facet: {},
        tipo_de_accesorio_polietileno_facet: {},
        tipo_portaherramientas_facet: {},
        tipo_de_radiador_toallero_facet: {},
        tipo_de_repuesto_facet: {},
        tipo_de_recogedor_manguera_facet: {},
        tipo_de_resistencia_facet: {},
        tipo_de_rosca_facet: {},
        sierra_facet: {},
        tipo_de_sifón_facet: {},
        tipo_de_soplete_facet: {},
        tipo_de_spa_facet: {},
        tipo_de_termostato_facet: {},
        tipo_de_unión_facet: {},
        tipo_de_válvula_facet: {},
        tobera_incluida_facet: {},
        tratamientos_facet: {},
        triturador_para_facet: {},
        tubería_de_riego_facet: {},
        uso_facet: {},
        tipo_de_circuito_facet: {},
        desagüe_facet: {},
        variedad_de_semilla_facet: {},
        vaso_hexagonal_facet: {},
        ventilador_de_techo_facet: {},
        volumen_de_agua_facet: {}
      },
      slots: { clear: SLOTS.facetsGroup.footer },
      slidingDirection: 'right'
    }
  }
};

export const DESKTOP_FACETS_CONFIG: DeepPartial<FacetsConfig> = {
  default: {
    facet: {
      showMoreButton: true,
      filtersToShow: 10,
      components: {
        icon: 'ChevronDownIcon',
        filter: {
          checkbox: 'TuandcoFacetsTick'
        }
      }

    }

  },

  groups: {
    'all-facets': {
      collapsible: true,
      startCollapsed: false,
      layoutDirection: 'vertical',
      templateSlots: {
        panel: SLOTS.template.leftAside,
        toggle: null
      },
      facets: {
        promociones_facet: {},
        hierarchical_category: {},
        price_facet: {},
        brand_facet: {},
        abonos_y_substratos_facet: {},
        acabado_facet: {},
        accesorio_facet: {},
        tipo_de_accesorio_facet: {},
        ventilador_accionado_por_facet: {},
        altura_ajustable_facet: {},
        altura_del_césped_facet: {},
        altura_facet: {},
        alto_mampara_facet: {},
        ancho_campana_facet: {},
        ancho_cortina_de_baño_facet: {},
        medida_de_ancho_facet: {},
        ángulo_de_la_bisagra_facet: {},
        angulo_de_riego_facet: {},
        arboles_facet: {},
        medida_arco_de_sierra_facet: {},
        asiento_facet: {},
        aspersores_facet: {},
        aumentos_facet: {},
        baños_en_casa_facet: {},
        medida_de_la_barrena_facet: {},
        bastidor_para_facet: {},
        boca_cuadrada_facet: {},
        boca_hexagonal_facet: {},
        caño_extraible_facet: {},
        capacidad_facet: {},
        capacidad_del_deposito_facet: {},
        capacidad_refrigeración_facet: {},
        caudal_facet: {},
        caudal_y_ángulo_de_la_boquilla_facet: {},
        diámetro_cazoleta_bisagra_facet: {},
        código_de_curva_facet: {},
        colección_facet: {},
        color_facet: {},
        columna_para_facet: {},
        tipo_de_combustible_facet: {},
        combustible_barbacoa_facet: {},
        conexión_del_termostato_facet: {},
        conjunto_facet: {},
        numero_de_cubetas_facet: {},
        medidas_cubierta_de_invierno_facet: {},
        medidas_cubierta_isotérmica_facet: {},
        depuradora_facet: {},
        punta_phillips_facet: {},
        punta_plana_facet: {},
        punta_pozidriv_facet: {},
        punta_recta_facet: {},
        punta_torx_facet: {},
        medida_del_botador_facet: {},
        medidas_diámetro_facet: {},
        medida_piscina_hinchable_facet: {},
        diámetro_tubería_facet: {},
        difusores_facet: {},
        tipo_de_duchas_facet: {},
        tipo_de_pulsación_facet: {},
        encendido_calentador_facet: {},
        entrada_de_agua_facet: {},
        espesor_del_aislamiento_facet: {},
        estaciones_facet: {},
        salida_facet: {},
        medida_de_fondo_facet: {},
        forma_de_la_maceta_facet: {},
        funcionamiento_limpiafondos_facet: {},
        funcionamiento_facet: {},
        grapadoras_y_clavadoras_facet: {},
        grosor_del_accesorio_facet: {},
        grosor_de_pared_facet: {},
        grosor_poste_facet: {},
        hacha_facet: {},
        herramientas_coche_facet: {},
        herramienta_de_medición_facet: {},
        importe_facet: {},
        incluido_en_el_mueble_facet: {},
        ahumador_facet: {},
        bomba_dosificadora_facet: {},
        incluye_freno_facet: {},
        grifo_lavapiés_facet: {},
        incluye_termostato_facet: {},
        incorpora_grill_facet: {},
        tipo_de_instalación_del_grifo_facet: {},
        intensidad_facet: {},
        intensidad_regulable_facet: {},
        envase_facet: {},
        largo_de_la_barra_facet: {},
        led_integrado_facet: {},
        capacidad_de_limpieza_facet: {},
        capacidad_en_litros_facet: {},
        tipos_de_llave_facet: {},
        herramienta_de_corte_facet: {},
        macetas_facet: {},
        mando_a_distancia_facet: {},
        con_mando_a_distancia_facet: {},
        mangueras_facet: {},
        manufacturer_facet: {},
        marchas_atrás_facet: {},
        material_cepillo_facet: {},
        material_mueble_jardín_facet: {},
        material_plato_de_ducha_facet: {},
        medidas_de_la_caja_facet: {},
        medidas_de_cortafrío_facet: {},
        medidas_formón_facet: {},
        medidas_de_las_llaves_facet: {},
        medida_macetas_y_jardín_facet: {},
        medidas_martillo_y_mazas_facet: {},
        medidas_mesa_cultivo_facet: {},
        medida_de_la_paleta_facet: {},
        medida_rejilla_facet: {},
        medidas_de_la_manta_protectora_facet: {},
        medidas_facet: {},
        medida_de_la_canal_facet: {},
        medida_del_flexo_facet: {},
        medida_de_las_grapas_facet: {},
        medida_máxima_piscina_facet: {},
        medida_de_métrica_facet: {},
        medida_piscina_de_acero_facet: {},
        medida_piscina_tubular_facet: {},
        medida_rosca_facet: {},
        medida_de_la_rueda_facet: {},
        caldera_con_microacumulación_facet: {},
        modelo_grifería_facet: {},
        modelo_accesorio_de_baño_facet: {},
        modelo_aire_acondicionado_facet: {},
        modelo_bomba_facet: {},
        modelo_caldera_facet: {},
        modelo_calentador_facet: {},
        modelo_compresor_facet: {},
        modelo_del_cuchillo_facet: {},
        modelo_depósito_facet: {},
        modelo_descalcificador_facet: {},
        modelo_estufa_facet: {},
        modelo_lampara_facet: {},
        modelo_de_limpiafondos_facet: {},
        modelo_llave_de_radiador_facet: {},
        modelo_mampara_facet: {},
        modelo_máquina_facet: {},
        modelo_mecanismos_facet: {},
        modelo_de_muebles_facet: {},
        modelo_de_ósmosis_facet: {},
        modelo_piscina_facet: {},
        modelo_plato_facet: {},
        modelo_quemador_facet: {},
        modelo_radiador_facet: {},
        modelo_sanitario_facet: {},
        modelo_termostato_facet: {},
        modelo_termo_eléctrico_facet: {},
        modelo_tirador_facet: {},
        modelo_urinario_facet: {},
        alimentación_facet: {},
        mordaza_facet: {},
        mueble_con_facet: {},
        mueble_de_jardín_facet: {},
        número_de_calzado_facet: {},
        numero_de_contadores_facet: {},
        número_de_polos_facet: {},
        número_de_fuegos_facet: {},
        marchas_hacia_adelante_facet: {},
        número_de_módulos_facet: {},
        número_de_salidas_facet: {},
        número_de_tomas_facet: {},
        orificio_para_grifería_facet: {},
        para_instalar_en_facet: {},
        para_mueble_de_facet: {},
        peldaños_facet: {},
        perfiles_de_la_mampara_facet: {},
        personas_en_casa_facet: {},
        pirolítico_facet: {},
        piscinas_y_juegos_infantiles_facet: {},
        época_de_siembra_facet: {},
        plantas_facet: {},
        plantilla_de_instalación_incluida_facet: {},
        posición_del_escurridor_facet: {},
        potencia_kw_facet: {},
        selecciona_la_potencia_facet: {},
        presentación_facet: {},
        capacidad_de_producción_acs_facet: {},
        puntas_del_alicate_facet: {},
        puntas_allen_facet: {},
        tipo_de_reductor_facet: {},
        tipo_de_regulación_facet: {},
        remachadoras_facet: {},
        rollo_de_facet: {},
        número_de_proyectores_facet: {},
        semillas_facet: {},
        programadores_facet: {},
        sierra_marquetería_facet: {},
        soldadores_facet: {},
        superficie_de_cocción_facet: {},
        superficie_de_la_vivienda_facet: {},
        talla_facet: {},
        tamaño_facet: {},
        tamaño_del_saco_facet: {},
        grifo_termostático_para_facet: {},
        termostato_programable_facet: {},
        tipo_aspersor_facet: {},
        tipo_abrazadera_facet: {},
        tipo_de_acceso_facet: {},
        tipo_accesorio_de_baño_facet: {},
        tipo_de_accesorio_fontanería_facet: {},
        tipo_de_accionamiento_facet: {},
        tipo_de_coquilla_facet: {},
        tipo_de_alcuza_facet: {},
        tipo_de_alicate_facet: {},
        apertura_de_la_mampara_facet: {},
        tipo_de_azada_facet: {},
        tipo_de_barbacoa_facet: {},
        tipo_de_barra_facet: {},
        batería_de_contadores_facet: {},
        tipo_de_bidé_facet: {},
        tipo_de_bisagra_facet: {},
        tipo_de_bombilla_facet: {},
        tipo_de_caja_facet: {},
        tipo_de_caldera_facet: {},
        salida_de_humos_facet: {},
        tipo_de_camisa_facet: {},
        tipo_de_caño_facet: {},
        tipo_de_carretilla_facet: {},
        tipo_de_casco_facet: {},
        tipo_de_casquillo_facet: {},
        tipo_de_cepillo_facet: {},
        tipo_chaqueta_facet: {},
        tipo_tableta_facet: {},
        uso_del_cuchillo_facet: {},
        tipo_de_depósito_facet: {},
        destornillador_facet: {},
        instalación_facet: {},
        tipo_de_césped_facet: {},
        tipo_instalacion_facet: {},
        portamangueras_facet: {},
        tipo_de_rejilla_facet: {},
        escalera_para_piscinas_facet: {},
        tipo_de_escalera_facet: {},
        tipo_de_espejo_facet: {},
        estilo_facet: {},
        tipo_de_flexómetro_facet: {},
        combustible_facet: {},
        tipo_de_grifo_facet: {},
        tipo_de_guante_facet: {},
        tipo_de_guía_facet: {},
        tipo_de_guías_facet: {},
        tipo_de_inodoro_facet: {},
        tipo_de_juego_facet: {},
        tipo_de_lámpara_facet: {},
        tipo_de_limpiafondos_facet: {},
        tipo_de_llave_facet: {},
        tipo_de_luz_facet: {},
        tipo_de_mampara_facet: {},
        tipo_de_máquina_facet: {},
        tipo_de_martillo_facet: {},
        tipo_mascarilla_facet: {},
        tipo_de_mecanismo_facet: {},
        tipo_de_mono_de_trabajo_facet: {},
        conjunto_de_facet: {},
        tipo_de_nivel_facet: {},
        tipo_organizador_facet: {},
        tipo_de_osmosis_facet: {},
        tipo_de_pala_facet: {},
        tipo_de_pantalla_de_soldar_facet: {},
        tipo_pantalón_facet: {},
        tipo_de_piscina_facet: {},
        tipo_placa_cocción_facet: {},
        tipo_de_accesorio_polietileno_facet: {},
        tipo_portaherramientas_facet: {},
        tipo_de_radiador_toallero_facet: {},
        tipo_de_repuesto_facet: {},
        tipo_de_recogedor_manguera_facet: {},
        tipo_de_resistencia_facet: {},
        tipo_de_rosca_facet: {},
        sierra_facet: {},
        tipo_de_sifón_facet: {},
        tipo_de_soplete_facet: {},
        tipo_de_spa_facet: {},
        tipo_de_termostato_facet: {},
        tipo_de_unión_facet: {},
        tipo_de_válvula_facet: {},
        tobera_incluida_facet: {},
        tratamientos_facet: {},
        triturador_para_facet: {},
        tubería_de_riego_facet: {},
        uso_facet: {},
        tipo_de_circuito_facet: {},
        desagüe_facet: {},
        variedad_de_semilla_facet: {},
        vaso_hexagonal_facet: {},
        ventilador_de_techo_facet: {},
        volumen_de_agua_facet: {}
      },
      components: {
        selectedFilters: {
          selectedFilters: COMPONENTS.PURE.SelectedFilters,
          removeIcon: 'TuandcoCloseIcon'
        }

      },
      slots: {
        selectedFilters: SLOTS.facetsGroup.header
      }

    }
  }
};
